


<navigation-button
  (click)="openCollectionItems()"
  [indent]="indent"
  [expandable]="listExplorerMode ? !!(lists$ | async)?.length : true"
  [disabled]="!canManage"
  [(expanded)]="expanded"
  (expandedChange)="onExpandedChange($event)">
  <ng-container icon>
    <scs-svg-icon name="library-shared"></scs-svg-icon>
  </ng-container> {{collection.name}}

  <ng-container addons>
    <navigation-button-addon *ngIf="loading$ | async">
      <fa-icon [icon]="['fas', 'circle-notch']" [spin]="true"></fa-icon>
    </navigation-button-addon>
  </ng-container>

  <ng-template #expandedTemplate>
    <navigation-button
      *ngIf="!listExplorerMode"
      (click)="openRecentItems()"
      [indent]="indent+1">
      <ng-container icon>
        <scs-svg-icon name="recent"></scs-svg-icon>
      </ng-container> Recently Read
    </navigation-button>

    <navigation-button
      *ngIf="!listExplorerMode"
      (click)="openFlaggedItems()"
      [indent]="indent+1">
      <ng-container icon>
        <scs-svg-icon name="flag"></scs-svg-icon>
      </ng-container> Flagged
    </navigation-button>

    <navigation-tags 
      *ngIf="!listExplorerMode"
      [collection]="collection" 
      [indent]="indent">
    </navigation-tags>

    <ng-container *ngIf="!listExplorerMode">
      <navigation-smartlist
        *ngFor="let list of smartLists$ | async"
        [indent]="indent+1"
        [collection]="collection"
        [list]="list">
      </navigation-smartlist>
    </ng-container>

    <navigation-list
      *ngFor="let node of lists$ | async"
      [indent]="indent+1"
      [maxDepth]="maxListsDepth"
      [collection]="collection"
      [node]="node"
      [canManage]="canManage"
      [listExplorerMode]="listExplorerMode"
      (onCreateList)="onCreateList.emit($event)">
    </navigation-list>

    <scs-loader *ngIf="loadingLists$ | async"></scs-loader>
  </ng-template>
  
</navigation-button>
